import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { SyncPaymentMethodInput } from './inputs';
import { PaymentMethodResource } from './resources';
import { PaymentMethodRef } from './refs';

export default class PaymentMethod {
    private basePath = '/api/payment-method';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Force-sync payment method
    sync = async (input: SyncPaymentMethodInput): Promise<PaymentMethodRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };

    // Get payment method list
    get = async (paymentAccountId: ID): Promise<CollectionResource<PaymentMethodResource, {}>> => {
        const query = qs.stringify({ payment_account_id: paymentAccountId });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get single payment method
    getById = async (id: ID): Promise<PaymentMethodResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Remove payment method
    remove = async (id: ID): Promise<PaymentMethodRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };
}
